import { createSelector } from 'reselect'

import { DEFAULT_CURRENCY, getCockpitFinancialPlanQualitySummary } from '../../lib'

import { selectCockpitActualsAndTargetsSettings } from './selectCockpitActualsAndTargetsSettings'
import { selectCockpitCategoriesByOffering } from './selectCockpitCategoriesByOffering'
import { selectCockpitCurrency } from './selectCockpitCurrency'
import { selectCockpitMetric } from './selectCockpitMetric'
import { selectCockpitOfferingPresentation } from './selectCockpitOfferingPresentation'
import { selectCockpitPeriods } from './selectCockpitPeriods'
import { selectCockpitSobMandatoryContext } from './selectCockpitSobMandatoryContext'
import { selectEffectiveCockpitActualsSync } from './selectEffectiveCockpitActualsSync'
import { selectVisibleCockpitFinSobRows } from './selectVisibleCockpitFinSobRows'

export const selectCockpitFinancialPlanQualityByOffering = createSelector(
  [
    selectVisibleCockpitFinSobRows,
    selectEffectiveCockpitActualsSync,
    selectCockpitMetric,
    selectCockpitCurrency,
    selectCockpitPeriods,
    selectCockpitOfferingPresentation,
    selectCockpitCategoriesByOffering,
    selectCockpitActualsAndTargetsSettings,
    selectCockpitSobMandatoryContext,
  ],
  (
    rows,
    { fYear, currentFQuarter, fQuarterActualsPercentage },
    actualsType,
    currency,
    periods,
    offeringPresentation,
    categoriesByOffering,
    settings,
    sobMandatoryContext
  ) =>
    getCockpitFinancialPlanQualitySummary({
      rows,
      fYear,
      actualsType,
      isLocalCurrency: currency !== DEFAULT_CURRENCY,
      periods,
      currentFQuarter,
      fQuarterActualsPercentage,
      offeringPresentation,
      categoriesByOffering,
      settings,
      sobMandatoryContext,
    })
)
